import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import { CONSULTANT_TYPE_LIST_REQUEST, CONSULTANT_TYPE_LIST_RECEIVED, CONSULTANT_TYPE_LIST_ERROR } from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const consultantTypeListRequest = () => ({
  type: CONSULTANT_TYPE_LIST_REQUEST,
});

export const consultantTypeListReceived = (data) => ({
  type: CONSULTANT_TYPE_LIST_RECEIVED,
  data,
});

export const consultantTypeListError = (error) => ({
  type: CONSULTANT_TYPE_LIST_ERROR,
  error,
});

export const consultantTypeListFetch = () => {
  return (dispatch) => {
    dispatch(consultantTypeListRequest());
    const filters = { pagination: false };
    return requests
      .get(API_ROUTES.CONSULTANT_TYPE, filters)
      .then((response) => dispatch(consultantTypeListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(consultantTypeListError(error));
      });
  };
};
